import { createFileRoute } from "@tanstack/react-router";
import { DailySalesReport } from "@/features/reports/daily-sales-report";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/sprzedaz-dzienna")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sprzedaz-dzienna",
			location.pathname,
		);
	},
	component: DailySalesReport,
});
